<template>
  <div class="icon-container">
    <div class="hello-and-icons is-flex">
      <div :class="`create-`+context" class="icons is-flex">
        <div v-for="item in icons" :key="item.name" @click="$emit('click', item.name)">
          <div class="icon-wrapper cursor-pointer is-primary" :class="'gtm-create-attachment-'+ item.name.toLowerCase()" v-bind="getTooltip(item)" >
            <span :class="{'icon-background': !isComment}" v-bind:style="{'height' : iconSize, 'width' : iconSize}">
              <i v-if="isComment" :class="item.commentIcon"></i>
              <img v-else v-bind:src="getImageIcon(item)"/>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/mixins/auth'
import breakpoints from '@/libs/breakpoints'
import i18n from '@/i18n'

export default {
  mixins: [auth],

  props: ['context'],

  data: function () {
    return {
      icons: [
        {
          name: 'imageorvideo',
          description: 'projectPage.photoVideo',
          image: '/static/icons/photo-video-icon.svg',
          commentIcon: 'fal fa-photo-video fa-lg'
        },
        {
          name: 'link',
          description: 'projectPage.link',
          image: '/static/icons/link-icon.svg',
          commentIcon: 'fal fa-link fa-lg'
        },
        {
          name: 'file',
          description: 'projectPage.file',
          image: '/static/icons/file-icon.svg',
          commentIcon: 'fal fa-file fa-lg'
        },
        {
          name: 'whiteboard',
          description: 'projectPage.whiteboard',
          image: '/static/icons/whiteboard-icon.svg',
          commentIcon: 'fal fa-chalkboard fa-lg'
        },
        {
          name: 'poll',
          description: 'projectPage.poll',
          image: '/static/icon-poll.svg',
          commentIcon: 'fal fa-poll-h fa-lg'
        }
      ]
    }
  },

  computed: {
    isComment: function () {
      return this.context === 'comment' || this.context === 'comment-update'
    },
    isMake: function () {
      return this.context === 'undefined'
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    iconSize: function () {
      return this.isComment || this.isMake ? '43px' : '60px'
    }
  },
  methods: {
    getTooltip: function (item) {
      const tooltip = {}
      if (!this.isMobile) {
        tooltip['data-balloon'] = i18n.t(item.description)
        tooltip['data-balloon-pos'] = 'up'
      }
      return tooltip
    },
    getImageIcon: function (item) {
      return this.isComment ? item.commentImage : item.image
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  // There are 6 types of postContext:
  //   create-post            Post page '/post'
  //   create-inline          Post from a project page
  //   create-inline-update   Edit a post in list view
  //   create-comment         Create + edit a comment
  //   create-comment-update  Edit a comment
  //   create-undefined       For Make -- ultimately will replace all but comment probably

  .icon-container {
    position: relative;

    .hello-and-icons {
      align-items: center;
      justify-content: space-between;
      @include mobile {
        flex-direction: column;
      }
    }
  }

  // Shared between all context types

  .icons {
    width: 100%;
    justify-content: flex-start;
    align-items: center;
    padding: 0.75rem 0;
    @include mobile {
      width: 100%;
      justify-content: space-around;
    }
    .icon-wrapper {
      margin-right: 1.5rem;
      align-items: center;
      text-align: center;
      @include mini-mobile {
        margin: 0 0.25rem;
      }
      img {
        margin: 0 auto;
        flex-shrink: 0;
        min-width: 100%;
        max-width: 100%;
      }
    }
    .icon-background {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      padding: 12px;
      background: $primary-gradient;
    }
    .name {
      display: block;
      text-align: center;
      margin-top: 10px;
      text-transform: uppercase;
      font-size: 0.65rem;
      @include mini-mobile {
        display: none;
      }
    }
  }

  // Context specific //

  .icons {

    &.create-undefined {
      justify-content: center;
    }

    &.create-post {
      @include mobile {
        justify-content: flex-start
      }
    }

    &.create-inline {
      justify-content: space-around;
      margin-left: 1rem;
      @include mobile {
        margin: 0;
        justify-content: space-around;
      }
    }

    &.create-inline-update {
      justify-content: space-around;
      padding: 2rem 0;
    }

    &.create-comment {
      .icon-background {
        padding: 12px;
      }
      .icon-wrapper {
        color: $grey-medium;
      }
      font-size: 1rem;
      justify-content: center;
      @include mobile {
        .text {
          display: none;
        }
      }
    }
  }

</style>
